import { AnchorButton, Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, useText } from "@sveabank/cc-common";

type Props = {
	applicationId: string;
	isOpen: boolean;
	setOpen: (isOpen: boolean) => void;
};

const ClcPaymentModal = ({ applicationId, isOpen, setOpen }: Props) => {
	const [t, texts] = useText();

	return (
		<Dialog
			isOpen={isOpen}
			setOpen={setOpen}
			size="small"
			center
			heading={t(texts.newCompany.paymentRemainderModal.heading)}
			icon="warning"
		>
			<Dialog.Content>{t(texts.newCompany.paymentRemainderModal.text)}</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<AnchorButton href={`/new-company/${applicationId}`}>
						{t(texts.newCompany.paymentRemainderModal.primaryButtonText)}
					</AnchorButton>
					<Button variant="secondary" onPress={() => setOpen(false)}>
						{t(texts.common.close)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};

export default ClcPaymentModal;
